// extracted by mini-css-extract-plugin
export default {"button":"OffersTableActionButton_button__F32ze"};